module.exports = __webpack_public_path__ + "media/5sec.10f187ab.mp3";